import { FunctionComponent, useEffect, useRef } from 'react';
import CleanBtn from './CleanBtn';
import Logs from './Logs';
interface Props {
  logs: string[];
  reset: () => void;
}

const Console: FunctionComponent<Props> = ({ logs, reset }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollTop = wrapperRef.current.scrollHeight;
    }
  }, [logs]);

  return (
    <div className="relative bg-zinc-900 h-full text-white">
      <div
        ref={wrapperRef}
        className="h-full overflow-y-auto overflow-x-hidden scroll-smooth scrollbar-thin scrollbar-thumb-slate-700 scrollbar-track-gray-900"
      >
        <Logs logs={logs} />
      </div>
      <CleanBtn onClick={() => reset()} />
    </div>
  );
};

export default Console;
